import { createSelector } from 'reselect';

const validityTargetSelector = state => state.validity.validityTargets;
export const getValidityTargets = createSelector(
    validityTargetSelector,
    validityTargets => validityTargets,
);
